export class DocumentsMapper {
  static responseUpdateDocuments(res) {
    const exceptWarnings = [
      "Cannot invoke \"java.util.List.forEach(java.util.function.Consumer)\" because the return value of \"com.aeromexico.rc.requireddocuments.model.updateDocuments.PassengerUpdateRequest.getPassengerIds()\" is null",
      "ERR.RB.DOCUMENTSUPDATESECURITY.INTERNAL_SERVER_ERROR, 500 Internal Server Error on POST request for \"http://am-rb-documents-update-security/rb/documentsUpdateSecurity/getStatusTimatic\": \"",
    ];
    const { warnings } = res;

    if (warnings && warnings?.length > 0) {
      const getFirstWarning = warnings.pop();

      if (exceptWarnings.includes(getFirstWarning.errorMessage)) {
        throw new Error(getFirstWarning);
      }
    }

    return res;
  }
}